import React, { Fragment } from 'react'
import { Row, Col, Input, Container, Button, Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import CollapseCard from '../CollapseCard/CollapseCard';
import ClientReportHeader from './ClientReportHeader';
import ClientReportTabs from './ClientReportTabs';

class ClientDailyStatus extends React.Component {

    render = () => {
        this.props.info('ClientDailyStatus.js/render');
        return (<>
            <CollapseCard title="Filters" open={false}>
                <Container className="text-left">
                    <Row>
                        <Col className="font-weight-bold" md={4}>Filter</Col>
                        <Col className="font-weight-bold" md={4}>Min</Col>
                        <Col className="font-weight-bold" md={4}>Max</Col>
                    </Row>
                    <Row>
                        <Col md={4}>Date</Col>
                        <Col md={4}><Input type="date" name="dateMin" value={this.props.isFieldNull(this.props.filters.dateMin)} onChange={(e) => this.props.changeFilter(e)} /></Col>
                        <Col md={4}><Input type="date" name="dateMax" value={this.props.isFieldNull(this.props.filters.dateMax)} onChange={(e) => this.props.changeFilter(e)} /></Col>
                    </Row>
                    <Row>
                        <Col md={4}>Securities</Col>
                        <Col md={4}><Input type="number" name="securitiesMin" value={this.props.isFieldNull(this.props.filters.securitiesMin)} onChange={(e) => this.props.changeFilter(e)} /></Col>
                        <Col md={4}><Input type="number" name="securitiesMax" value={this.props.isFieldNull(this.props.filters.securitiesMax)} onChange={(e) => this.props.changeFilter(e)} /></Col>
                    </Row>
                    <Row>
                        <Col md={4}>Accounts</Col>
                        <Col md={4}><Input type="number" name="accountsMin" value={this.props.isFieldNull(this.props.filters.accountsMin)} onChange={(e) => this.props.changeFilter(e)} /></Col>
                        <Col md={4}><Input type="number" name="accountsMax" value={this.props.isFieldNull(this.props.filters.accountsMax)} onChange={(e) => this.props.changeFilter(e)} /></Col>
                    </Row>
                    <Row>
                        <Col md={4}>Reconciled</Col>
                        <Col md={4}><Input type="number" name="reconMin" value={this.props.isFieldNull(this.props.filters.reconMin)} onChange={(e) => this.props.changeFilter(e)} /></Col>
                        <Col md={4}><Input type="number" name="reconMax" value={this.props.isFieldNull(this.props.filters.reconMax)} onChange={(e) => this.props.changeFilter(e)} /></Col>
                    </Row>
                    <Row>
                        <Col md={4}>Unreconciled</Col>
                        <Col md={4}><Input type="number" name="unreconMin" value={this.props.isFieldNull(this.props.filters.unreconMin)} onChange={(e) => this.props.changeFilter(e)} /></Col>
                        <Col md={4}><Input type="number" name="unreconMax" value={this.props.isFieldNull(this.props.filters.unreconMax)} onChange={(e) => this.props.changeFilter(e)} /></Col>
                    </Row>
                    <Row>
                        <Col md={4}>Timer</Col>
                        <Col md={8}><Input type="select" name="timer" value={this.props.isFieldNull(this.props.filters.timer)} onChange={(e) => this.props.changeFilter(e)} >
                            <option value="">Select</option>
                            <option value="Not Started">Not Started</option>
                            <option value="In Progress">In Progress</option>
                            <option value="Finished">Finished</option>
                        </Input></Col>
                    </Row>
                </Container>
            </CollapseCard>
            {
                this.props.clientReports != null && this.props.clientReports.reports != null && this.props.clientReports.reports.length > 0 ?
                    <Table className="py-0">
                        <thead>
                            <tr>
                                <th width="15%" className="text-left">Date</th>
                                <th width="15%">New Securities</th>
                                <th width="15%">New Accounts</th>
                                <th width="15%">Recon.</th>
                                <th width="15%">Unrecon.</th>
                                <th width="25%">Timer</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.clientReports.reports.filter(report =>
                                report.date.substring(0, 10) >= (this.props.filters.dateMin != null ? this.props.filters.dateMin : '1970-01-01')
                                && report.date.substring(0, 10) <= (this.props.filters.dateMax != null ? this.props.filters.dateMax : '2040-12-31')
                                && report.securities.length >= (!isNaN(parseInt(this.props.filters.securitiesMin)) ? parseInt(this.props.filters.securitiesMin) : -1)
                                && report.securities.length <= (!isNaN(parseInt(this.props.filters.securitiesMax)) ? parseInt(this.props.filters.securitiesMax) : Number.POSITIVE_INFINITY)
                                && report.accounts.length >= (!isNaN(parseInt(this.props.filters.accountsMin)) ? parseInt(this.props.filters.accountsMin) : -1)
                                && report.accounts.length <= (!isNaN(parseInt(this.props.filters.accountsMax)) ? parseInt(this.props.filters.accountsMax) : Number.POSITIVE_INFINITY)
                                && report.reconciled.length >= (!isNaN(parseInt(this.props.filters.reconMin)) ? parseInt(this.props.filters.reconMin) : -1)
                                && report.reconciled.length <= (!isNaN(parseInt(this.props.filters.reconMax)) ? parseInt(this.props.filters.reconMax) : Number.POSITIVE_INFINITY)
                                && report.unreconciled.length >= (!isNaN(parseInt(this.props.filters.unreconMin)) ? parseInt(this.props.filters.unreconMin) : -1)
                                && report.unreconciled.length <= (!isNaN(parseInt(this.props.filters.unreconMax)) ? parseInt(this.props.filters.unreconMax) : Number.POSITIVE_INFINITY)
                                && ((report.timeTracking == null && this.props.filters.timer === 'Not Started') || this.props.filters.timer !== 'Not Started')
                                && (((report.timeTracking != null && report.timeTracking.filter(item => item.endTimestamp == null).length > 0) && this.props.filters.timer === 'In Progress') || this.props.filters.timer !== 'In Progress')
                                && (((report.timeTracking != null && report.timeTracking.filter(item => item.endTimestamp != null).length > 0) && this.props.filters.timer === 'Finished') || this.props.filters.timer !== 'Finished')
                            ).filter((report, index) => index < this.props.showing).map((report, index) => (
                                <Fragment key={index}><ClientReportHeader
                                    {...this.props}
                                    report={report}
                                    active={report.id === this.props.selectedClientReportId}
                                />
                                    {(report.id === this.props.selectedClientReportId) ?
                                        <ClientReportTabs
                                            {...this.props}
                                            report={report}
                                            selectedClientReportId={this.props.selectedClientReportId}
                                            selectedReport={this.props.selectedReport}
                                            handleReconciliationTextInputChange={this.props.handleReconciliationTextInputChange}
                                            submitReconciliation={this.props.submitReconciliation}
                                            handleUpload={this.props.handleUpload}
                                            uploadSuccess={this.props.uploadSuccess}
                                            saveSuccess={this.props.saveSuccess}
                                            randomKey={this.props.randomKey}
                                            files={this.props.files}
                                            formatAMPM={this.props.formatAMPM}
                                            changeTab={this.props.changeTab}
                                        />
                                        : <></>}
                                </Fragment>
                            ))}
                            {this.props.showing < this.props.clientReports.reports.length ?
                                <tr><td colSpan="7"><Button color="primary" onClick={(e) => this.setState({ showing: this.props.showing + this.increment })}>More</Button></td></tr>
                                : <></>}
                        </tbody>
                    </Table> : <>No Reports</>
            }
            {/* </CollapseCard> */}
        </>)
    }
}

export default ClientDailyStatus;